// Same palette as the admin tool's bright-frame action.
export const BRIGHT_FRAME_COLORS = [
  '#FFD166', '#7DE2D1', '#90DBF4', '#B9FBC0', '#FFB5E8', '#FDE74C',
  '#A9DEF9', '#D0F4DE', '#E4C1F9', '#FFCF99', '#C6F68D', '#9BF6FF',
] as const;
export function randomFrameColor(): string {
  return BRIGHT_FRAME_COLORS[Math.floor(Math.random() * BRIGHT_FRAME_COLORS.length)];
}
